import { inject, injectable } from "inversify";
import type { UserType } from "@whatslly/types/User";
import { webScriptBackend } from "@whatslly/instant-messaging/webScriptBackend";
import { WebScriptCommands } from "@whatslly/commons/webScriptCommands";
import type { IStorage } from "@whatslly/commons/storage.constants";
import { InjectStorage, STORAGE } from "@whatslly/commons/storage.constants";
import { action, computed, makeObservable, observable, runInAction } from "mobx";
import type { IMSelectorsUnion } from "@whatslly/types/integrations/im/IMSelectorsTypes";
@injectable()
export class IMUserStore<TSelectors = IMSelectorsUnion> {
  private _user?: UserType = undefined;
  public selectors?: TSelectors = undefined;

  constructor(@inject(InjectStorage) private readonly storage: IStorage) {
    makeObservable(this, {
      init: action,
      _user: observable.ref,
      reset: action,
      user: computed,
      setUser: action,
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } as any);
  }

  reset() {
    this._user = undefined;
  }

  get user() {
    return this._user;
  }

  setUser(user: UserType) {
    this._user = user;
  }

  async init(selectors: TSelectors) {
    this.selectors = selectors;
    webScriptBackend
      .on(WebScriptCommands.LOGOUT, () => this.reset())
      .on([WebScriptCommands.AUTH, WebScriptCommands.USER_REFRESHED], (data) => {
        runInAction(() => {
          if (data?.user) {
            this._user = data.user;
          }
        });
      });

    const userObj = await this.storage.get(STORAGE.USER);

    runInAction(() => {
      this._user = userObj || undefined;
    });
  }
}
